<script>
import LayoutPlain from "./components/layout/LayoutPlain.vue";
import LayoutAdmin from "./components/layout/LayoutAdmin.vue";
import FontDocument from "./components/widget/document/FontDocument.vue";
import ESignatures from "./components/layout/ESignaturesComponents.vue";
import { useUIStore } from "@/stores/ui";
import { mapState } from "pinia";

export default {
  data() {
    return {
      fontIsOpened: false,
    };
  },
  components: { LayoutAdmin, LayoutPlain, FontDocument, ESignatures },
  computed: {
    ...mapState(useUIStore, ["layout", "loading"]),
  },
  methods: {
    setFont() {
      this.fontIsOpened = false;
    },
    },
  triggerESeal(event) {
    // Kirim sinyal global bahwa tombol e-seal diklik
    window.dispatchEvent(new CustomEvent("on-eseal-click", { detail: event }));
  },
};
</script>

<template>
  <div class="min-h-screen flex flex-col overflow-x-hidden">
    <component :is="layout" />
    <div
      class="bg-black bg-opacity-50 fixed inset-0 flex justify-center items-center z-50 backdrop-blur-sm"
      v-show="loading"
    >
      <span class="loading loading-ring loading-lg text-rose-600"></span>
    </div>
  </div>
  <div class="signer-overlay">
    <div class="signer-overlay-header">
      <div class="signer-overlay-logo">
        <a href="/"
          ><img src="/img/polri-logo.png" class="h-10 lg:ml-4 img-header"
        /></a>
      </div>
      <div class="signer-overlay-action space-x-2">
        <button
          class="btn btn-sm btn-responsive btn-default close-editor-overlay"
        >
          <font-awesome-icon :icon="['far', 'circle-xmark']" class="w-4 h-4" />
          Batal
        </button>
        <button
          class="btn btn-sm btn-responsive bg-rose-600 hover:bg-rose-700 text-white"
          id="sign-pin"
        >
          <font-awesome-icon :icon="['far', 'circle-check']" class="w-4 h-4" />
          Simpan
        </button>
        <button
          class="btn btn-sm btn-responsive btn-primary signer-next"
          index="1"
        >
          <i class="ion-ios-checkmark-outline"></i> <span>Next</span>
        </button>
      </div>
      <div class="signer-header-tools">
        <div class="signer-header-tool-holder">
          <ESignatures />
          <div class="signer-tool space-y-1" tool="signature" action="true">
            <font-awesome-icon
              :icon="['fas', 'pen-fancy']"
              class="h-4 w-4 text-red-500"
            />
            <p>Tanda Tangan</p>
          </div>
          <div
            class="signer-tool parafclick space-y-1"
            tool="signature2"
            action="true"
          >
            <font-awesome-icon
              :icon="['fas', 'pen-fancy']"
              class="h-4 w-4 text-yellow-500"
            />
            <p>Paraf</p>
          </div>
            <!-- Segel Elektronik -->
          <!-- <div 
            class="signer-tool space-y-1 cursor-pointer" 
            tool="e-seal-polri" 
            action="true"
            @click="triggerESeal"
          >
            <font-awesome-icon :icon="['fas', 'stamp']" class="h-4 w-4 text-amber-500" />
            <p>Segel Elektronik</p>
          </div> -->
          <!--<div class="signer-tool" tool="stamp" action="true">
            <div class="tool-icon tool-stamp"></div>
            <p>R/Stamp</p>
            </div>-->
          <div class="signer-tool space-y-1" tool="text" action="true">
            <font-awesome-icon
              :icon="['fas', 't']"
              class="w-4 h-4 text-purple-500"
            />
            <p>Nomer Dokumen</p>
          </div>

          <div class="signer-tool space-y-1" tool="duplicate" action="false">
            <font-awesome-icon
              :icon="['far', 'clone']"
              class="w-4 h-4 text-teal-500"
            />
            <p>Duplikat</p>
          </div>
          <div class="signer-tool space-y-1" tool="delete" action="false">
            <font-awesome-icon
              :icon="['fas', 'trash-can']"
              class="w-4 h-4 text-rose-500"
            />
            <p>Hapus</p>
          </div>
          <!--
            <div class="signer-tool" tool="draw" action="true">
            <div class="tool-icon tool-draw"></div>
            <p>Draw</p>
            </div>
            <div class="signer-tool" tool="image" action="true">
            <div class="tool-icon tool-image"></div>
            <p>Image</p>
            </div>
            <div class="signer-tool" tool="symbol" action="true">
            <div class="tool-icon tool-symbols"></div>
            <p>Symbols</p>
            </div>
            <div class="signer-tool" tool="shape" action="true">
            <div class="tool-icon tool-shapes"></div>
            <p>Shapes</p>
            </div>
            <div class="signer-tool" tool="fields" action="true">
            <div class="tool-icon tool-fields"></div>
            <p>Fields</p>
            </div>
                    <div class="signer-tool" tool="input" action="true">
            <div class="tool-icon tool-textinput"></div>
            <p>Input</p>
            </div>
                    <div class="signer-tool" tool="rotate" action="true">
            <div class="tool-icon tool-rotate"></div>
            <p>Rotate</p>
            </div>-->
        </div>
      </div>
    </div>

    <div class="signer-more-tools">
      <div
        class="signer-tool space-y-1"
        tool="alignleft"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'align-left']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Rata Kiri</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="aligncenter"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'align-center']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Rata Tengah</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="alignright"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'align-right']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Rata Kanan</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="bold"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'bold']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Bold</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="italic"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'italic']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Italic</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="underline"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'underline']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Underline</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="strikethrough"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'strikethrough']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Strikethrough</p>
      </div>
      <div
        class="signer-tool space-y-1"
        tool="font"
        action="false"
        group="text"
      >
        <font-awesome-icon
          :icon="['fas', 'font']"
          class="w-4 h-4 text-slate-600"
        />
        <p>Font</p>
      </div>
      <div class="signer-tool" tool="fontsize" action="false">
        <div class="tool-icon tool-fontsize">
          <div class="numberInput">
            <input
              v-sanitize
              type="text"
              class="font-size"
              value="14"
              min="0"
            />
            <span class="arrow up"></span>
            <span class="arrow down"></span>
          </div>
        </div>
        <p class="font-size-label">Font Size</p>
      </div>
      <!-- <div class="signer-tool" tool="color" action="false" color="#000000">
        <div class="tool-icon tool-colorfill">
          <button
            id="color-picker"
            class="jscolor {valueElement:null,value:'000000', borderRadius:'1px', borderColor:'#e6eaee', onFineChange:'updateColor(this)'}"
          ></button>
        </div>
        <p>Warna</p>
      </div> -->
    </div>

    <div
      class="signer-overlay-previewer w-min flex flex-col items-center light-card"
    ></div>
    <div class="signer-assembler"></div>
    <div class="signer-builder"></div>
    <div class="request-helper">
      Select input fields and signature position for <strong></strong>
    </div>
    <font-document
      v-if="fontIsOpened"
      @close="fontIsOpened = false"
      @selectFont="setFont"
    />
  </div>
</template>
